<template>
	<div>
	  <SubTopNav :title="title" :image="image" />
	  <div v-html="content" id="htmlBody" class="content"></div>
	  
  </div>
</template>
<script>
// @ is an alias to /src
	import SubTopNav from "@/components/SubTopNav.vue";
	import { RepositoryFactory } from "@/repositories/RepositoryFactory"
  	const ContentRepository = RepositoryFactory.get("content");

	export default {
	  name: "about",
	  components: {
	    SubTopNav
	  },
	  data: function(){
	  	return {
	  		content: null,
	  		image: null,
	  		title: null
	  	}
	  },
	  methods: {
	  	async getAboutPage(){
	  		var type = "page"
	        var id = "1"
	        const { data } = await ContentRepository.get(type, id)

	        this.title = data[0].title[0].value

	        if (data.length > 0){
	          this.content = data[0].body[0].value

	          var htmlBody = this.content
	          htmlBody = new DOMParser().parseFromString(htmlBody, "text/html")
	          // this.content = this.content.replace("src=\"", "src=\"http://yokeserver.com");
	          var images = htmlBody.getElementsByTagName("img")
	          // console.log('image length', htmlBody.body.innerHTML)
	          for (var i = 0; i < images.length; i++){
	          	var img = htmlBody.getElementsByTagName("img")[i]
	          	var align = img.getAttribute('data-align')
	          	var src = img.src
	          	var origin = window.location.origin
	          	var className = ''
	          	if (align == 'left'){
	          		className = 'leftImage'
	          		htmlBody.getElementsByTagName("img")[i].setAttribute("style", "margin: 0px 25px 25px 0px;float:left;max-width:100%");
	          	} else {
	          		className = 'rightImage'
	          		htmlBody.getElementsByTagName("img")[i].setAttribute("style", "margin: 0px 0px 25px 25px; float:right;max-width:100%");
	          	}

	          	var baseDomain = process.env.VUE_APP_SITE_DOMAIN
	          	src = src.replace(origin, baseDomain)
	          	htmlBody.getElementsByTagName("img")[i].src = src
	          	htmlBody.getElementsByTagName("img")[i].classList.add(className)
	          		// console.log('src', img)
	          	
	          }

	          this.content = htmlBody.body.innerHTML

	          // images.forEach(function(img){
	          // 	console.log('img', img)
	          // })
	          if (data[0].field_page_header_image.length > 0){
	          	this.image = data[0].field_page_header_image[0].url
	          }
	          
	        }
	  	}
	  },
	  mounted(){
	  	this.getAboutPage()
	  }
	};
</script>
<style scoped>
	.about{
		text-align:left;
	}

	img.leftImage {
		float:left;
	}



	.page-image img{
		max-width:100%;
	}

	.page-image{
		background-size:cover;
	}

	.square{
		width:50%;
		overflow:hidden;
	}

	.square.blue{
		clear:both;
		float:right;
		background:rgba(0,102,255,0.8);
	}

	.square.green{
		background:rgba(0,153,51,0.8);
	}

	.square.yellow{
		background:#FFFF00;
		clear:both;
		margin-bottom:20px;
	}

	.square:after {
	  content: "";
	  display: block;
	  padding-bottom: 100%;
	}



</style>
